import { SectionList } from "react-native";
import type { FontSchemaType } from "../../font";
import { useDevice } from "../../useDevice";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { CustomListSubheader } from "../CustomListSubheader";
import ScrollContainer from "../ScrollContainer";
import MoreSettingsListItem from "./MoreSettingsListItem";
import type { MoreSettingsItem, MoreSettingsSection } from "./types";

interface Props {
	sections: MoreSettingsSection[];
	handleClickMoreSettingsItem: (type: MoreSettingsItem) => void;
	appFont: FontSchemaType;
}

const MoreApplet = ({
	sections,
	handleClickMoreSettingsItem,
	appFont,
}: Props) => {
	const { isMobile } = useDevice();
	const Wrapper = isMobile ? Box : FlatCard;
	return (
		<ScrollContainer
			maxWidth="sm"
			// biome-ignore lint/a11y/useSemanticElements: <explanation>
			role="main"
		>
			<Wrapper
				style={{
					marginVertical: 16,
				}}
			>
				<SectionList
					sections={sections}
					scrollEnabled={false}
					renderSectionHeader={({ section: { sectionTitle } }) => {
						return (
							<CustomListSubheader font={appFont}>
								{sectionTitle}
							</CustomListSubheader>
						);
					}}
					renderItem={({ item }) => {
						return (
							<MoreSettingsListItem
								item={item}
								handleClick={handleClickMoreSettingsItem}
							/>
						);
					}}
				/>
			</Wrapper>
		</ScrollContainer>
	);
};

export default MoreApplet;
